var React = require('react');

function ToolIllustrator (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("rect",{"x":"23.2","y":"14","width":"3.2","height":"12.7","key":0}),React.createElement("circle",{"cx":"24.8","cy":"10.9","r":"1.6","key":1}),React.createElement("path",{"d":"M16.3,9.3h-3.6L7.6,26.7h3.2l1.3-4.8h4.3l1.4,4.8h3.3L16.3,9.3z M12.6,19.4l1.8-6.6l1.5,6.6H12.6z","key":2})]));
}

ToolIllustrator.defaultProps = {"version":"1.0","width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = ToolIllustrator;

ToolIllustrator.default = ToolIllustrator;
